import { useEffect, useState } from 'react';

import { getLatestModelTimesApi } from '../api';
import { LatestModelTimesApiResponse } from '../types';

const useLatestModelTimes = () => {
  const [latestTimes, setLatestTimes] =
    useState<LatestModelTimesApiResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const fetchLatestTimes = async (): Promise<void> => {
      setIsLoading(true);
      const data = await getLatestModelTimesApi();
      if (isMounted) {
        setLatestTimes(data);
        setIsLoading(false);
      }
    };
    fetchLatestTimes();
    return () => {
      isMounted = false;
    };
  }, []);

  return { latestTimes, isLoading };
};

export default useLatestModelTimes;
